import React from 'react';
import './Index.css'

const DMSComponent = () => {
  return (
    <section className="bg-gradient-to-r from-blue-50 to-white py-12 background-gradient background-gradient-2">
      <h2 className="text-center text-3xl font-bold mb-8">
        Comprehensive DMS Solution for Diverse Industries
      </h2>
          <div className="container-fluid mx-auto ">
                    <div className="grid grid-cols-12  lg:mb-5  lg:gap-10">
                        <div className="lg:col-span-3 col-span-6 ">
                            <div className="expteam mx-5 p-4 h-full flex flex-col items-center">
                                <img src={require('../../assets/img/automobile.png') } className="w-15 mt-2" alt="Automobile" />
                                <p className="pt-2 mb-0 info-text">Automobile</p>
                            </div>
                        </div>
                        <div className="lg:col-span-3 col-span-6 ">
                            <div className="expteam mx-5 p-4 h-full flex flex-col items-center">
                                <img src={require('../../assets/img/manufacturing.png')} className="w-15 mt-2" alt="Manufacturing" />
                                <p className="pt-2 mb-0 text-xl info-text">Manufacturing</p>
                            </div>
                        </div>
                        <div className="lg:col-span-3 col-span-6 mt-4 lg:mt-0 ">
                            <div className="expteam mx-5 p-4 h-full flex flex-col items-center">
                                <img src={require('../../assets/img/rcg.png')} className="w-15 mt-2" alt="RCG" />
                                <p className="pt-2 mb-0 text-xl info-text">RCG</p>
                            </div>
                        </div>
                        <div className="lg:col-span-3 col-span-6 mt-4 lg:mt-0 info-box">
                            <div className="expteam mx-5 p-4 h-full flex flex-col items-center">
                                <img src={require('../../assets/img/finance.png')} className="w-15 mt-2" alt="Finance" />
                                <p className="pt-2 mb-0 text-xl info-text">Finance</p>
                            </div>
                        </div>
                    </div>
 
                    <div className="grid grid-cols-12 text-center lg:pt-7 pt-5 lg:gap-10">
                        <div className="lg:col-span-3 col-span-6 ">
                            <div className="expteam mx-5 p-4 h-full flex flex-col items-center">
                                <img src={require('../../assets/img/education.png')} className="w-15 mt-2" alt="Education" />
                                <p className="pt-2 mb-0 info-text">Education</p>
                            </div>
                        </div>
                        <div className="lg:col-span-3 col-span-6 ">
                            <div className="expteam mx-5 p-4 h-full flex flex-col items-center">
                                <img src={require('../../assets/img/healthcare.png')} className="w-15 mt-2" alt="Health Care" />
                                <p className="pt-2 mb-0 text-xl info-text">Health Care</p>
                            </div>
                        </div>
                        <div className="lg:col-span-3 col-span-6 mt-4 lg:mt-0 ">
                            <div className="expteam mx-5 p-4 h-full flex flex-col items-center">
                                <img src={require('../../assets/img/realestate.png') } className="w-15 mt-2" alt="Real Estate" />
                                <p className="pt-2 mb-0 text-xl info-text">Real Estate</p>
                            </div>
                        </div>
                        <div className="lg:col-span-3 col-span-6 mt-4 lg:mt-0 ">
                            <div className="expteam mx-5 p-4 h-full flex flex-col items-center">
                                <img src={require('../../assets/img/ecom.png')} className="w-15 mt-2" alt="Client-Centric Approach" />
                                <p className="pt-2 mb-0 text-xl info-text">Ecommerce</p>
                            </div>
                        </div>
                    </div>
                </div>
    </section>
  );
};

export default DMSComponent;


 
